import { Controller } from '@hotwired/stimulus'

// Reveals the convention detail fields only when the "yes" radio is selected.
export default class extends Controller {
  static targets = ['fields', 'radio']

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.radioTargets.find((radio) => radio.checked)
    this.fieldsTarget.classList.toggle('hidden', selected?.value !== 'yes')
  }
}
